

import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dropdown } from "react-bootstrap";
import { FaWallet } from "react-icons/fa";

import { FaPlus,FaEdit, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { 
  FaMoneyBillWave,
  FaRupeeSign,
  FaCalendarAlt,

} from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
const Viewusers = () => {
  const [users, setUsers] = useState([]);
  const [editUser, setEditUser] = useState(null);
  const [filter, setFilter] = useState("all");
  const [paymentModal, setPaymentModal] = useState(false);
  const [referralData, setReferralData] = useState([]);
  const [referralModal, setReferralModal] = useState(false);
const [wallet, setWallet] = useState(null);
const [previewImage, setPreviewImage] = useState(null);
const [confirmOpen, setConfirmOpen] = useState(false);
const [confirmData, setConfirmData] = useState({
  title: "",
  message: "",
  onConfirm: null,
});

// console.log(editUser,'user in edit')
const ConfirmModal = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div style={overlay}>
      <div style={modal}>
        <h3>{title}</h3>
        <p style={{ margin: "10px 0 20px" }}>{message}</p>

        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button
            onClick={onCancel}
            style={{
              padding: "8px 14px",
              background: "#ccc",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            style={{
              padding: "8px 14px",
              background: "#16a34a",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

const fetchWallet = async (userId) => {
  try {

    const res = await axios.get(
      `https://api.statixtrading.in/api/wallet/${userId}`
    );



    if (res.data.success) {

      const walletData = res.data.data[0];

      setWallet({
        deposit: Number(walletData.deposit || 0),
        withdraw: Number(walletData.withdraw || 0),
        balance: Number(walletData.balance || 0),
      });

    }

  } catch (err) {

    console.log(err);

  }
};
// const [paymentData, setPaymentData] = useState({
//   userId: null,
//   amount: "",
//   datetime: "",
// });
const [paymentData, setPaymentData] = useState({
  userId: null,
  amount: "",
  datetime: "",
  trans_type: "Deposit",
});
  useEffect(() => {
    fetchUsers();
  }, []);



  const handleReferral = async (userid) => {
  try {

    const res = await axios.get(
      `https://api.statixtrading.in/api/fetch-referal/${userid}`
    );

    if (res.data.success) {
     setReferralData(res.data.data);
     
setReferralModal(true);
      
    }

  } catch (error) {
    console.log(error);
  }
};



const handleAddPayment = (userId) => {
setPaymentData({
  userId,
  amount: "",
  datetime: new Date().toISOString().slice(0, 16),
  trans_type: "Deposit",
});
  setPaymentModal(true);
};
const handlePaymentChange = (e) => {
  const { name, value } = e.target;
  setPaymentData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  const fetchUsers = async () => {
    try {
      const res = await axios.get("https://api.statixtrading.in/api/users");
      setUsers(res.data.data);
       
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (id) => {
    try {
      const res = await axios.get(`https://api.statixtrading.in/api/users/${id}`);
      setEditUser(res.data.data);
    
    } catch (error) {
      console.error("Edit fetch error", error);
    }
  };

  
  const toggleStatus = async (id, currentStatus) => {
  try {

    const newStatus = currentStatus === 1 ? 0 : 1;

    await axios.put(
      `https://api.statixtrading.in/api/user-status/${id}`,
      {
        status: newStatus,
      }
    );

    fetchUsers();

    toast.success(
      newStatus === 1
        ? "User Activated"
        : "User Deactivated"
    );

  } catch (error) {

    console.error(error);

    toast.error("Status update failed");
  }
};

const handlePreviewImage = (url, file) => {
  let finalUrl = "";

  if (file) {
    finalUrl = URL.createObjectURL(file);
  } else if (url) {
    finalUrl = url;
  } else {
    return;
  }

  const isPdf =
    finalUrl.toLowerCase().includes(".pdf") ||
    file?.type === "application/pdf";

  if (isPdf) {

    window.open(finalUrl, "_blank");
  } else {
  
    window.open(finalUrl, "_blank");
  }
};
  const submitPayment = async () => {

  try {
      const response = await axios.post(
      "https://api.statixtrading.in/api/add-payment",
      paymentData
    );

    toast.success("Payment Added Successfully");

    setPaymentModal(false);

  } catch (error) {

    console.error(
      "PAYMENT ERROR =>",
      error
    );

    console.log(
      "ERROR RESPONSE =>",
      error?.response?.data
    );

    toast.error("Error adding payment");
  }
};
  const toggleKyc = async (field, value) => {
  try {

    const newValue = value === 1 ? 0 : 1;

    await axios.put(
      `https://api.statixtrading.in/api/kyc-verify/${editUser.id}`,
      {
        [field]: newValue,
      }
    );

    setEditUser((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    setUsers((prev) =>
      prev.map((u) =>
        u.id === editUser.id
          ? { ...u, [field]: newValue }
          : u
      )
    );

    let label = "";

    if (field === "aadhar_verified") {
      label = "Aadhaar";
    } else if (field === "pan_verified") {
      label = "PAN";
    } else if (field === "bank_verified") {
      label = "Bank";
    }

    toast.success(
      `${label} ${
        newValue === 1 ? "Verified" : "Unverified"
      }`
    );

  } catch (error) {

    console.error(error);

    toast.error("KYC Update Failed");
  }
};
  const filteredUsers = users.filter((user) => {
    if (filter === "active") return user.is_status === 1;
    if (filter === "inactive") return user.is_status === 0;
    return true;
  });
  const openConfirm = (title, message, onConfirm) => {
  setConfirmData({ title, message, onConfirm });
  setConfirmOpen(true);
};

const closeConfirm = () => {
  setConfirmOpen(false);
  setConfirmData({ title: "", message: "", onConfirm: null });
};

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>View  User</h1>

      <div style={buttonContainer}>
        <button style={getBtnStyle(filter === "all", "#a8aeb6")} onClick={() => setFilter("all")}>All</button>
        <button style={getBtnStyle(filter === "active", "#28a745")} onClick={() => setFilter("active")}>Active</button>
        <button style={getBtnStyle(filter === "inactive", "#dc3545")} onClick={() => setFilter("inactive")}>Inactive</button>
      </div>

      <div style={cardStyle}>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>SN</th>
              <th style={thStyle}>User ID</th>
              <th style={thStyle}>Account Holder Name</th>
              <th style={thStyle}>Mobile</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredUsers.map((user,index) => (
              <tr key={user.id} style={rowStyle}>
                <td>{filteredUsers.length-index}</td>
                <td>{user.userid}</td>
                <td>{user.account_holder_name}</td>
                <td>{user.mobile_no}</td>
                <td>{user.email}</td>

        <td>

  <Dropdown>

    <Dropdown.Toggle
      variant="light"
      id={`dropdown-${user.id}`}
      style={{
        border: "none",
        fontSize: "20px",
        fontWeight: "bold",
        background: "#f1f1f1",
        color: "#000",
        padding: "4px 10px",
      }}
    >
      ⋮
    </Dropdown.Toggle>

    <Dropdown.Menu>

      <Dropdown.Item
        onClick={() =>
          toggleStatus(user.id, user.is_status)
        }
      >
        {user.is_status === 1 ? (
          <>
            <FaTimesCircle /> Deactivate
          </>
        ) : (
          <>
            <FaCheckCircle /> Activate
          </>
        )}
      </Dropdown.Item>

      <Dropdown.Item
        onClick={() => handleEdit(user.id)}
      >
        <FaEdit /> Edit
      </Dropdown.Item>

      <Dropdown.Item
        onClick={() => handleAddPayment(user.id)}
      >
        <FaPlus /> Add Payment
      </Dropdown.Item>

      <Dropdown.Item
        onClick={() => handleReferral(user.userid)}
      >
        <FaUserFriends /> Referral
      </Dropdown.Item>
{/* <Dropdown.Item onClick={() => fetchWallet(user.id)}>
  <FaWallet style={{ marginRight: "8px" }} />
  Wallet
</Dropdown.Item> */}
    </Dropdown.Menu>


  </Dropdown>

</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
 {/* {wallet && (
  <div style={overlay}>
    <div style={modal}>

      <h3>Wallet Balance</h3>

      <p><b>Deposit:</b> ₹{wallet.deposit}</p>

      <p><b>Withdraw:</b> ₹{wallet.withdraw}</p>

      <p><b>Balance:</b> ₹{wallet.balance}</p> 
<button
  onClick={() => setWallet(null)}
  style={{
    position: "absolute",
    top: "10px",
    right: "12px",
    border: "none",
    background: "transparent",
    fontSize: "26px",
    cursor: "pointer",
    color: "#555",
    fontWeight: "bold",
  }}
>
  ×
</button> 

     </div>
  </div>
)} */}

  {referralModal && (
  <div style={overlay}>
    <div style={modal}>


      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <h3 style={{ margin: 0 }}>
          Referral History
        </h3>

        <button
          onClick={() => setReferralModal(false)}
          style={{
            border: "none",
            background: "transparent",
            fontSize: "26px",
            cursor: "pointer",
            color: "#0e0d0d",
            fontWeight: "bold",
          }}
        >
          ×
        </button>
      </div>


      {referralData.length > 0 ? (
        <table style={{ width: "100%" }}>

          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Coins</th>
            </tr>
          </thead>

          <tbody>
            {referralData.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>

                <td>
                  {item.users_name || "-"}
                </td>

                <td>
                  {item.users_mobile || "-"}
                </td>

                <td>
                  {item.coins || 0}
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      ) : (
        <p>No Referral Found</p>
      )}

    </div>
  </div>
)}

{paymentModal && (
  <div style={overlay}>
    <div style={modalBox}>


      <div style={modalHeader}>
        <h3
          style={{
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          <FaMoneyBillWave /> Add Payment
        </h3>

        
        <button
          onClick={() => setPaymentModal(false)}
          style={closeBtn}
        >
          ×
        </button>
      </div>

      
      <div style={modalBody}>
        <div style={inputGroup}>
          <FaRupeeSign style={iconStyle} />
          <input
            name="amount"
            value={paymentData.amount}
            onChange={handlePaymentChange}
            placeholder="Enter Amount"
            style={inputStyle}
          />
        </div>

        <div style={inputGroup}>
          <FaCalendarAlt style={iconStyle} />
          <input
            type="datetime-local"
            name="datetime"
            value={paymentData.datetime}
            onChange={handlePaymentChange}
            style={inputStyle}
          />
        </div>
      </div>

      
      <div style={modalFooter}>
        <button onClick={submitPayment} style={saveBtn}>
          <FaCheckCircle style={{ marginRight: "6px" }} />
          Save
        </button>
      </div>

    </div>
  </div>
)}

   {editUser && (
  <div style={overlay}>
    <div style={modal}>


      <button
        onClick={() => setEditUser(null)}
        style={topCloseBtn}
      >
        ×
      </button>

      <h3>User Details</h3>

    
      <p><b>Email:</b> {editUser.email}</p>
      <p><b>Mobile:</b> {editUser.mobile_no}</p>

      <hr />

      <div style={{ marginBottom: "10px" }}>
        <div style={rowFlex}>
          <span>Aadhaar</span>
          {/* <button
            onClick={() =>
              toggleKyc("aadhar_verified", editUser.aadhar_verified)
            }
            style={smallBtn(editUser.aadhar_verified)}
          >
            {editUser.aadhar_verified == 1 ? "Verified" : "Verify"}
          </button> */}
<button
  onClick={() =>
    editUser.aadhar_verified == 1
      ? null
      : openConfirm(
          "Confirm Aadhaar Verification",
          "Are you sure you want to verify Aadhaar?",
          () => {
            toggleKyc("aadhar_verified", editUser.aadhar_verified);
            closeConfirm();
          }
        )
  }
  style={{
    ...smallBtn(editUser.aadhar_verified),
    cursor: editUser.aadhar_verified == 1 ? "not-allowed" : "pointer",
    opacity: editUser.aadhar_verified == 1 ? 0.6 : 1,
  }}
  disabled={editUser.aadhar_verified == 1}
>
  {editUser.aadhar_verified == 1 ? "Verified" : "Verify"}
</button>
        </div>

        <p
          style={{
            margin: "4px 0 0 0",
            fontSize: "13px",
            color: "#555",
          }}
        >
          Aadhaar No: {editUser.aadhaar_no}
        </p>
      </div>
      <div
  style={{
    display: "flex",
    gap: "10px",
    marginTop: "10px",
    flexWrap: "wrap",
  }}
>
  {editUser.aadhaar_front && (
    <div>
      <p
        style={{
          fontSize: "12px",
          marginBottom: "4px",
        }}
      >
        Front
      </p>

      {/* <img
        src={`https://api.statixtrading.in/uploads/${editUser.aadhaar_front}`}
        alt="Aadhaar Front"
        style={{
          width: "120px",
          height: "80px",
          objectFit: "cover",
          borderRadius: "6px",
          border: "1px solid #ddd",
        }}
      /> */}
      {/* <img
  src={`https://api.statixtrading.in/uploads/${editUser.aadhaar_front}`}
  alt="Aadhaar Front"
  style={imageStyle}
/> */}

<button
  onClick={() =>
    handlePreviewImage(
      `https://api.statixtrading.in/uploads/${editUser.aadhaar_front}`
    )
  }
  style={previewBtn}
>
  Preview
</button>
    </div>
  )}

  {editUser.aadhaar_back && (
    <div>
      <p
        style={{
          fontSize: "12px",
          marginBottom: "4px",
        }}
      >
        Back
      </p>
{/* 
      <img
        src={`https://api.statixtrading.in/uploads/${editUser.aadhaar_back}`}
        alt="Aadhaar Back"
        style={{
          width: "120px",
          height: "80px",
          objectFit: "cover",
          borderRadius: "6px",
          border: "1px solid #ddd",
        }}
      /> */}
      
<button
  onClick={() =>
    handlePreviewImage(
      `https://api.statixtrading.in/uploads/${editUser.aadhaar_back}`
    )
  }
  style={previewBtn}
>
  Preview
</button>
    </div>
  )}
</div>

      <div style={{ marginBottom: "10px" }}>
        <div style={rowFlex}>
          <span>PAN</span>
          {/* <button
            onClick={() =>
              toggleKyc("pan_verified", editUser.pan_verified)
            }
            style={smallBtn(editUser.pan_verified)}
          >
            {editUser.pan_verified == 1 ? "Verified" : "Verify"}
          </button> */}
          <button
  onClick={() => {
    if (editUser.pan_verified == 1) return;

    openConfirm(
      "Confirm PAN Verification",
      "Are you sure you want to verify PAN?",
      () => {
        toggleKyc("pan_verified", editUser.pan_verified);
        closeConfirm();
      }
    );
  }}
  style={{
    ...smallBtn(editUser.pan_verified),
    cursor: editUser.pan_verified == 1 ? "not-allowed" : "pointer",
    opacity: editUser.pan_verified == 1 ? 0.6 : 1,
  }}
  disabled={editUser.pan_verified == 1}
>
  {editUser.pan_verified == 1 ? "Verified" : "Verify"}
</button>
        </div>

        <p
          style={{
            margin: "4px 0 0 0",
            fontSize: "13px",
            color: "#555",
          }}
        >
          PAN: {editUser.pan_no}
        </p>
      </div>
      {editUser.pan_docs && (
  <div style={{ marginTop: "10px" }}>

    <p
      style={{
        fontSize: "12px",
        marginBottom: "4px",
      }}
    >
      PAN Image
    </p>

    {/* <img
      src={`https://api.statixtrading.in/uploads/${editUser.pan_docs}`}
      alt="PAN"
      style={{
        width: "140px",
        height: "90px",
        objectFit: "cover",
        borderRadius: "6px",
        border: "1px solid #ddd",
      }}
    /> */}
    
<button
  onClick={() =>
    handlePreviewImage(
      `https://api.statixtrading.in/uploads/${editUser.pan_docs}`
    )
  }
  style={previewBtn}
>
  Preview
</button>
  </div>
)}

      <div style={rowFlex}>
        <span>Bank</span>
        {/* <button
          onClick={() =>
            toggleKyc("bank_verified", editUser.bank_verified)
          }
          style={smallBtn(editUser.bank_verified)}
        >
          {editUser.bank_verified == 1 ? "Verified" : "Verify"}
        </button> */}
        <button
  onClick={() => {
    if (editUser.bank_verified == 1) return;

    openConfirm(
      "Confirm Bank Verification",
      "Are you sure you want to verify Bank details?",
      () => {
        toggleKyc("bank_verified", editUser.bank_verified);
        closeConfirm();
      }
    );
  }}
  style={{
    ...smallBtn(editUser.bank_verified),
    cursor: editUser.bank_verified == 1 ? "not-allowed" : "pointer",
    opacity: editUser.bank_verified == 1 ? 0.6 : 1,
  }}
  disabled={editUser.bank_verified == 1}
>
  {editUser.bank_verified == 1 ? "Verified" : "Verify"}
</button>
      </div>

      <div style={bankBox}>
        <p>IFSC: {editUser.ifsc_code}</p>
        <p>Acc: {editUser.account_number}</p>
        <p>Holder: {editUser.account_holder_name}</p>
      </div>

    <button
      onClick={() =>
        handlePreviewImage(
        `https://api.statixtrading.in/uploads/${editUser.bank_docs}`
        )
      }
      style={previewBtn}
    >
      View PDF 
    </button>

    </div>
  </div>
)}
<ConfirmModal
  open={confirmOpen}
  title={confirmData.title}
  message={confirmData.message}
  onConfirm={confirmData.onConfirm}
  onCancel={closeConfirm}
/>
<ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};
const paymentBtn = {
  marginLeft: "6px",
  padding: "6px",
  background: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
};


const modalBox = {
  background: "#fff",
  padding: "0",
  borderRadius: "12px",
  width: "95%",
  maxWidth: "380px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  overflow: "hidden",
  boxSizing: "border-box",
};


const modalHeader = {
  position: "relative",
  padding: "15px",
};

const closeBtn = {
  position: "absolute",
  top: "10px",
  right: "10px",
  border: "none",
  background: "transparent",
  fontSize: "22px",
  cursor: "pointer",
  color: "#555",
};

const modalBody = {
  padding: "20px",
};

const modalFooter = {
  display: "flex",
  justifyContent: "space-between",
  padding: "15px 20px",
  borderTop: "1px solid #eee",
  gap: "10px",
};



const containerStyle = {
  padding: "20px",
  background: "#f4f6f9",
  minHeight: "100vh",
  fontFamily: "Arial",
  width: "100%",
  boxSizing: "border-box",
};

const titleStyle = {
    display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  marginBottom: "20px",
  color: "#1e293b",
  fontWeight: "700",
  fontSize: "30px",

};

const buttonContainer = {
  display: "flex",
  gap: "10px",
  marginBottom: "20px",
  flexWrap: "wrap",
};

const getBtnStyle = (active, color) => ({
  padding: "8px 16px",
  borderRadius: "6px",
  border: "none",
  cursor: "pointer",
  background: active ? color : "#ddd",
  color: active ? "#fff" : "#333",
  fontSize: "14px",
});

const cardStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
  overflowX: "auto",
};

// const tableStyle = {
//   width: "100%",
//   borderCollapse: "collapse",
//    borderSpacing: "0 10px",
// };
const tableStyle = {
  width: "100%",
  minWidth: "700px",
  borderCollapse: "separate",
  borderSpacing: "0 10px",
};

const thStyle = {
  padding: "12px",
  background: "#a8aeb6",
  color: "#fff",
  textAlign: "center",
  fontSize: "14px",
};


// const rowStyle = {
//   textAlign: "center",
//   borderBottom: "1px solid #eee",
  
// };

const rowStyle = {
  textAlign: "center",
  borderBottom: "1px solid #eee",
  background: "#fff",
};

const statusBtn = {
  border: "none",
  color: "#fff",
  padding: "6px 10px",
  borderRadius: "5px",
  marginRight: "6px",
  cursor: "pointer",
};

const editBtn = {
  background: "#4b9be6",
  color: "#fff",
  border: "none",
  padding: "6px 10px",
  borderRadius: "5px",
  cursor: "pointer",
  marginRight: "6px",
};

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px",
  boxSizing: "border-box",
  zIndex: 999,
};

// const modal = {
//   background: "#fff",
//   padding: "25px",
//   borderRadius: "10px",
//   width: "420px",
// };
const modal = {
  position: "relative",
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "95%",
  maxWidth: "420px",
  maxHeight: "90vh",
  overflowY: "auto",
  boxSizing: "border-box",
};


const topCloseBtn = {
  position: "absolute",
  top: "10px",
  right: "12px",
  border: "none",
  background: "transparent",
  fontSize: "24px",
  cursor: "pointer",
  color: "#555",
  fontWeight: "bold",
};

const rowFlex = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "10px",
};

const smallBtn = (active) => ({
  padding: "5px 12px",
  border: "none",
  borderRadius: "5px",
  background: active == 1 ? "#28a745" : "#6c757d",
  color: "#fff",
  cursor: "pointer",
});

const bankBox = {
  background: "#f1f3f5",
  padding: "10px",
  borderRadius: "6px",
  marginBottom: "10px",
  fontSize: "13px",
};

// const closeBtn = {
//   width: "100%",
//   padding: "10px",
//   background: "#dc3545",
//   color: "#fff",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };
const saveBtn = {
  padding: "8px 14px",
  background: "#28a745",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  width: "100%",
  maxWidth: "120px",
  fontSize: "15px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto",
};
const cancelBtn = {
  flex: 1,
  padding: "10px",
  background: "#dc3545",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const inputGroup = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "12px",
  border: "1px solid #ddd",
  padding: "8px",
  borderRadius: "6px",
  background: "#fff",
};

const iconStyle = {
  color: "#4b9be6",
};
const imageStyle = {
  width: "120px",
  height: "80px",
  objectFit: "cover",
  borderRadius: "6px",
  border: "1px solid #ddd",
};

const previewBtn = {
  marginTop: "5px",
  padding: "4px 8px",
  fontSize: "12px",
  border: "none",
  background: "#007bff",
  color: "#fff",
  borderRadius: "4px",
  cursor: "pointer",
};

const inputStyle = {
  width: "100%",
  border: "none",
  outline: "none",
  fontSize: "14px",
  background: "transparent",
};
;

export default Viewusers;








